import React, { useEffect, useState, useRef } from 'react';
import { fetchData } from '../utils/apiHelpers';
import { getAll } from '../api';
import $ from 'jquery';
import { Icon } from '@iconify/react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import Select from 'react-select';
import {
  createAssetCriticality,
  updateAssetCriticality,
  deleteAssetCriticality,
  getAssetCriticality
} from '../api/asset-criticalityAPI';

const CriticalityListLayer = () => {
  const userProfile = useUserProfile();
  const [criticalityList, setCriticalityList] = useState([]);
  const [colours, setColourList] = useState([]);
  const [newCrit, setNewCrit] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});

  const tableRef = useRef(null);
  const dtRef = useRef(null);

  const colourOptions = colours.map(c => ({
    value: c.id,
    label: c.name,
    bootstrapName: c.bootstrapName,
  }));

  const fetchCriticality = async () => {
    try {
      const data = await getAssetCriticality();
      setCriticalityList(data);
    } catch (err) {
      console.error('Error fetching criticality:', err);
    }
  };


  const validateForm = () => {
    const newErrors = {};
    if (!newCrit.criticalityName?.trim()) newErrors.criticalityName = 'Criticality is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    fetchCriticality();
    fetchData(getAll, { apiName: 'colours' }, setColourList);
  }, []);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.destroy();
      dtRef.current = null;
    }
    if (criticalityList.length > 0) {
      dtRef.current = $(tableRef.current).DataTable({
        pageLength: 25,
        dom: 'rtp',
        responsive: false,
        language: {
          paginate: { first: '', last: '', next: '', previous: '' },
        },
      });
    }
    return () => {
      if (dtRef.current) {
        dtRef.current.destroy(true);
        dtRef.current = null;
      }
    };
  }, [criticalityList]);

  useEffect(() => {
    if (dtRef.current) {
      dtRef.current.search(searchTerm).draw();
    }
  }, [searchTerm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCrit((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setNewCrit(item);
    setEditingId(item.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this criticality?')) return;
    try {
      await deleteAssetCriticality(id);
      // repaint the table
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }
      await fetchCriticality();
    } catch (error) {
      console.error('Error deleting criticality:', error);
    }
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    try {
      const cleanPayload = {};
      for (const key in newCrit) {
        if (newCrit[key] !== null && typeof newCrit[key] !== 'object') {
          cleanPayload[key] = newCrit[key];
        }
      }

      if (editingId) {
        await updateAssetCriticality(editingId, cleanPayload);
      } else {
        await createAssetCriticality(cleanPayload);
      }

      setShowModal(false);
      setEditingId(null);

      // repaint the table
      if (dtRef.current) {
        dtRef.current.destroy();
        dtRef.current = null;
      }

      setNewCrit({});
      await fetchCriticality();
    } catch (error) {
      console.error('Error saving criticality:', error);
    }
  };

  return (
    <div className="card h-100 p-0 rounded-0">
      <div className="card-header d-flex justify-content-between align-items-center p-3">
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {userProfile?.privileges?.includes('asset-criticality:create') && (
          <button
            className="btn btn-primary text-sm btn-sm px-16 py-12 radius-4 d-flex align-items-center gap-2"
            onClick={() => {
              setNewCrit({});
              setEditingId(null);
              setShowModal(true);
            }}
          >
            <Icon icon="ic:baseline-plus" className="icon text-xl" />
            Add Criticality
          </button>
        )}
      </div>

      <div className="card-body p-0">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table mb-0 w-100 rounded-0" ref={tableRef}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Colour Code</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {criticalityList.map((item) => (
                <tr key={item.id}>
                  <td><strong>{item.criticalityName}</strong></td>
                  <td>
                    <span className={`d-inline-block rounded-1 bg-${item.colours?.bootstrapName}`} style={{ width: '10px', height: '10px', marginRight: '8px' }}></span>
                    {item.colours?.name}
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      {userProfile?.privileges?.includes('asset-criticality:update') && (
                      <button
                        className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        onClick={() => handleEdit(item)}
                      >
                        <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                      </button>
                      )}
                      {userProfile?.privileges?.includes('asset-criticality:delete') && (
                      <button
                        className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        onClick={() => handleDelete(item.id)}
                      >
                        <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                      </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editingId ? 'Edit Criticality' : 'New Criticality'}</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Name *</label>
                    <input
                      className={`form-control ${errors.criticalityName ? 'is-invalid' : ''}`}
                      name="criticalityName"
                      value={newCrit.criticalityName || ''}
                      onChange={handleInputChange}
                    />
                    {errors.criticalityName && <div className="invalid-feedback">{errors.criticalityName}</div>}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Colour Code *</label>
                    <Select
                      name="coloursId"
                      classNamePrefix={`react-select ${errors.coloursId ? 'is-invalid' : ''}`}
                      value={colourOptions.find(opt => opt.value === newCrit.coloursId) || null}
                      onChange={(opt) =>
                        handleInputChange({ target: { name: 'coloursId', value: opt?.value || '' } })
                      }
                      options={colourOptions}
                      isClearable
                      placeholder="Select Colour"
                      formatOptionLabel={(opt) => (
                        <div className="d-flex align-items-center gap-2">
                          <span className={`d-inline-block rounded-1 bg-${opt.bootstrapName}`} style={{ width: '10px', height: '10px' }}></span>
                          {opt.label}
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button className="btn btn-primary" onClick={handleSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CriticalityListLayer;
